





















import {
  Vue,
  Component,
  Prop,
  Watch,
} from 'vue-property-decorator';
import { filters } from '@/components/filters/filters-config';
import SourceApi from '@/services/source';
import { Variable, VariableResults } from '@/models/variable';
import store from '@/store';

const filterComponents = filters
  .reduce((obj, item) => Object.assign(obj, { [`${item.type}_filter`]: () => item.filterComponent }), {});

@Component({
  components: {
    ...filterComponents,
  },
})
export default class FilterContainer extends Vue {
  // todo: some things may have moved to child component. check.
  @Prop({ required: true }) variable!: Variable;

  sourceApi = new SourceApi();

  queryResult: any | null = null;

  created(): void {
    const encrypted = this.variable.query.startsWith('encrypted_');

    this.sourceApi.query(this.variable.sourceUUID, this.variable.query, encrypted).then((response) => {
      if (response.success) {
        this.queryResult = response.result;
      } else {
        console.log('err', response);
      }
    });
  }
}
